import { lazy } from "react";
import { dashboardSVG } from "../shared/helpers/icons";

const EntryPoint = lazy(() => import(/* webpackChunkName: "Dashboard - EntryPoint" */ "./components/EntryPoint"));
const DashboardPage = lazy(() => import(/* webpackChunkName: "Dashboard - Dashboard" */ "./components/Dashboard"));
const MetricsPage = lazy(() => import(/* webpackChunkName: "Dashboard - Metrics" */ "./components/Metrics"));
const ConfigPage = lazy(() => import(/* webpackChunkName: "Dashboard - Config" */ "./components/Config"));

export const defaultPath = "/dashboard";

export const innerRoutes = [
  {
    path: `${defaultPath}/`,
    Component: DashboardPage,
    exact: true,
    icon: dashboardSVG,
    title: { key: "", plural: false },
    subTitle: { key: "", plural: false },
  },
  {
    path: `${defaultPath}/metrics`,
    Component: MetricsPage,
    exact: true,
    icon: dashboardSVG,
    title: { key: "", plural: false },
    subTitle: { key: "", plural: false },
  },
  {
    path: `${defaultPath}/config`,
    Component: ConfigPage,
    exact: true,
    icon: dashboardSVG,
    title: { key: "", plural: false },
    subTitle: { key: "", plural: false },
  },
];

const Dashboard = {
  path: defaultPath,
  Component: EntryPoint,
  exact: false,
  icon: dashboardSVG,
  title: { key: "dashboard", plural: false },
  subTitle: { key: "dashboard_detail", plural: false },
  innerRoutes,
};

export default Dashboard;
